import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onChange", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Input from '@jd/jmtd/es/Input';
import Select from '@jd/jmtd/es/Select';
import GeRealtime from '../GeRealtime';
import stateAdapter from './stateAdapter';
export var Adapters = new WeakMap();
Adapters.set(Input, {
  render: function render(_ref) {
    var props = _ref.props,
        showConfirm = _ref.showConfirm,
        context = _ref.context,
        setContext = _ref.setContext;

    var onChange = props.onChange,
        value = props.value,
        other = _objectWithoutProperties(props, _excluded);

    return {
      props: showConfirm ? _objectSpread({
        showSearch: true,
        value: context,
        onSearch: function onSearch() {
          onChange(context);
        },
        onChange: setContext
      }, other) : _objectSpread({
        onChange: onChange,
        value: value
      }, other)
    };
  },
  reducer: function reducer(_ref2) {
    var setContext = _ref2.setContext,
        getProps = _ref2.getProps,
        showConfirm = _ref2.showConfirm;

    if (showConfirm) {
      setContext(getProps().value);
    }
  }
});
Adapters.set(Select, {
  render: function render(_ref3) {
    var props = _ref3.props,
        showConfirm = _ref3.showConfirm,
        loading = _ref3.loading;
    return {
      props: _objectSpread(_objectSpread({
        showConfirm: showConfirm
      }, props), {}, {
        loading: loading
      })
    };
  }
});
Adapters.set(GeRealtime, stateAdapter);